import { Provider } from "react-redux";
import { store } from "@/store/store";
import { I18nextProvider } from "react-i18next";
import { AppRoutes } from "@/app-routes";
import { PostHogProvider } from "posthog-js/react";
import { isNonProduction } from "./lib/utils";
import { ThemeProvider } from "./contexts/ThemeProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import i18n from "@/i18n/config";
import "@/lib/init-sentry";

const POSTHOG_OPTIONS = {
  api_host: import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_HOST,
  // Disable session recording to prevent stack overflow on iOS WebKit
  // (rrweb DOM serialization exceeds iOS's smaller call stack limit)
  disable_session_recording: true,
  autocapture: true,
  capture_pageview: true,
};

export function App() {
  if (isNonProduction()) {
    return (
      <ThemeProvider>
        <TooltipProvider delayDuration={300}>
          <Provider store={store}>
            <I18nextProvider i18n={i18n}>
              <AppRoutes />
            </I18nextProvider>
          </Provider>
        </TooltipProvider>
      </ThemeProvider>
    );
  }

  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_KEY}
      options={POSTHOG_OPTIONS}
    >
      <ThemeProvider>
        <TooltipProvider delayDuration={300}>
          <Provider store={store}>
            <I18nextProvider i18n={i18n}>
              <AppRoutes />
            </I18nextProvider>
          </Provider>
        </TooltipProvider>
      </ThemeProvider>
    </PostHogProvider>
  );
}
